var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.teamMemberships,
      expression: "loading.teamMemberships"
    }],
    attrs: {
      "title": "team memberships"
    }
  }, [_c('Table', {
    attrs: {
      "items": _vm.teamMemberships,
      "columns": _vm.columns,
      "actions": _vm.actions,
      "links": _vm.links,
      "filterProp": "team_name",
      "loading": _vm.loading.events
    }
  })], 1), _c('Dialog', {
    attrs: {
      "show": _vm.showEditDialog,
      "onClose": _vm.closeEditDialog
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "200px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Created at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.editItem.created_at,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "created_at", $$v);
      },
      expression: "editItem.created_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Team name"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.editItem.team_name,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "team_name", $$v);
      },
      expression: "editItem.team_name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Access Level"
    }
  }, [_c('el-select', {
    model: {
      value: _vm.editItem.access_level,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "access_level", $$v);
      },
      expression: "editItem.access_level"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "contributor",
      "label": "Contributor"
    }
  }), _c('el-option', {
    attrs: {
      "value": "viewer",
      "label": "Viewer"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Active projects count"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "step-strictly": ""
    },
    model: {
      value: _vm.editItem.active_projects_count,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "active_projects_count", $$v);
      },
      expression: "editItem.active_projects_count"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.editItem.user_email,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "user_email", $$v);
      },
      expression: "editItem.user_email"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "ID"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.editItem.id,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "id", $$v);
      },
      expression: "editItem.id"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Agency"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.editItem.is_agency,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "is_agency", $$v);
      },
      expression: "editItem.is_agency"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Archived"
    }
  }, [_c('el-switch', {
    model: {
      value: _vm.editItem.is_archived,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "is_archived", $$v);
      },
      expression: "editItem.is_archived"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    model: {
      value: _vm.editItem.role,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "role", $$v);
      },
      expression: "editItem.role"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "member",
      "label": "Member"
    }
  }), _c('el-option', {
    attrs: {
      "value": "owner",
      "label": "Owner"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Team"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: _vm.editItem.team,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "team", $$v);
      },
      expression: "editItem.team"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Team Plan"
    }
  }, [_c('el-select', {
    model: {
      value: _vm.editItem.team_plan,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "team_plan", $$v);
      },
      expression: "editItem.team_plan"
    }
  }, _vm._l(_vm.team_plans, function (item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item,
        "label": item
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Team slug"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.editItem.team_slug,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "team_slug", $$v);
      },
      expression: "editItem.team_slug"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Updated at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: _vm.editItem.updated_at,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "updated_at", $$v);
      },
      expression: "editItem.updated_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "User color"
    }
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: _vm.editItem.user_color,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "user_color", $$v);
      },
      expression: "editItem.user_color"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "User ID"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.editItem.user_user_id,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "user_user_id", $$v);
      },
      expression: "editItem.user_user_id"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "User name"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.editItem.user_name,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "user_name", $$v);
      },
      expression: "editItem.user_name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "User profile picture url"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.editItem.user_profile_picture_url,
      callback: function ($$v) {
        _vm.$set(_vm.editItem, "user_profile_picture_url", $$v);
      },
      expression: "editItem.user_profile_picture_url"
    }
  })], 1), _c('el-form-item', [!_vm.editItem.is_deleted ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.removeMembership
    }
  }, [_vm._v("Remove")]) : _vm._e(), _vm.editItem.is_deleted ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.restoreMembership
    }
  }, [_vm._v("Restore ")]) : _vm._e(), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _c('el-button', {
    on: {
      "click": function ($event) {
        return _vm.closeEditDialog();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _c('Dialog', {
    attrs: {
      "show": _vm.showApiKeyDialog,
      "onClose": _vm.closeApiKeyDialog,
      "title": "API Key"
    }
  }, [_c('div', {
    staticClass: "api-key-dialog"
  }, [_c('h3', [_vm._v("API Key")]), _c('div', {
    staticClass: "api-key-container"
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('el-button', {
          on: {
            "click": _vm.copyApiKey
          }
        }, [_c('i', {
          staticClass: "el-icon-document-copy"
        }), _vm._v(" Copy ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.generatedApiKey,
      callback: function ($$v) {
        _vm.generatedApiKey = $$v;
      },
      expression: "generatedApiKey"
    }
  })], 1), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeApiKeyDialog
    }
  }, [_vm._v("Close")])], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }